import { action } from "@ember/object"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import styles from "./create-modal.module.css"
import type { CourseModalModel } from "./edit-modal"

export interface CourseCreateModalSignature {
  Args: {
    model: CourseModalModel
    order: number
    closeModal: () => void
  }
}

export default class CourseCreateModal extends Component<CourseCreateModalSignature> {
  readonly styles = styles
  @tracked isSmall = false

  @action
  setSmallWidth() {
    this.isSmall = true
  }
  @action
  setNormalWidth() {
    this.isSmall = false
  }
}
